/**
 * POS-I360: the shop's default currency when it is a switched-on, non-PKR currency with a rate (else null: PKR only,
 * also while the list loads or is unavailable offline). Shares the `currencies-active` query with the checkout dialog.
 */
import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import type { Currency } from '@/types/pos';

export function useDefaultCurrency(): Currency | null {
  const isOnline = useOnlineStatus();
  const { data } = useQuery<Currency[]>({
    queryKey: ['currencies-active'],
    queryFn: () => api.get('/currencies/active').then((r) => r.data),
    staleTime: 10 * 60 * 1000,
    enabled: isOnline,
  });
  return (data ?? []).find((c) => c.isDefault && c.isActive && c.code !== 'PKR' && Number(c.exchangeRate) > 0) ?? null;
}
